import { render, staticRenderFns } from "./ProdutosItens.vue?vue&type=template&id=97787866&"
import script from "./ProdutosItens.vue?vue&type=script&lang=js&"
export * from "./ProdutosItens.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosItens.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports